import { format } from 'date-fns';
import { Calendar } from './calendar/calendar';
import { Popover, PopoverContent, PopoverTrigger } from './popover';
import ICONS from '@/common-utils/enums/icons';
import Icon from '../renders/icon/Icon';
import { cn } from '@/common-utils/libraries/tailwind/utils';
import { Button } from './button';
import { useTranslation } from 'react-i18next';
import Entity from '../renders/entity/Entity';
import PropTypes from 'prop-types';

/**
 * @param root0
 * @param root0.selected
 * @param root0.onSelect
 * @param root0.placeholder
 * @param root0.disableBeforeToday
 * @param root0.disableAfterToday
 * @param root0.className
 * @returns {JSX}
 */
export function DateInput({
    selected,
    onSelect,
    placeholder = '',
    disableBeforeToday,
    disableAfterToday,
    className
}) {
    // Language
    const i18n = useTranslation();

    // Detect appropriate format
    const getFormat = () => {
        switch (i18n.i18n.language) {
            case 'fr': {
                return 'dd/MM/yyyy';
            }
            default: return 'MM/dd/yyyy';
        }
    };

    return (
        <Popover>
            <PopoverTrigger asChild>
                <Button
                    variant={'outline'}
                    className={cn(
                        'w-full h-10 justify-between text-left font-normal',
                        !selected && 'text-muted-foreground',
                        className
                    )}
                >
                    <Entity
                        className={cn(selected ? 'font-normal' : 'font-light', 'text-sm')}
                        entity={selected ? format(selected, getFormat()) : placeholder.entity}
                        namespace={selected ? '' : placeholder.namespace}
                    />
                    <Icon icon={ICONS.CALENDAR} />
                </Button>
            </PopoverTrigger>
            <PopoverContent className='w-auto p-0 z-2001' align='start'>
                <Calendar
                    mode='single'
                    selected={selected}
                    onSelect={onSelect}
                    disableBeforeToday={disableBeforeToday}
                    disableAfterToday={disableAfterToday}
                />
            </PopoverContent>
        </Popover>
    );
}

DateInput.propTypes = {
    selected: PropTypes.instanceOf(Date),
    onSelect: PropTypes.func,
    placeholder: PropTypes.shape({
        entity: PropTypes.string,
        namespace: PropTypes.string
    }),
    disableBeforeToday: PropTypes.bool,
    disableAfterToday: PropTypes.bool,
    className: PropTypes.string
};